export const RECOVERY_BANNER_FLAG = 'isRecoveryBannerEnabled'
export const RECOVERY_BANNER_REVOKE_URL = 'https://revoke.cash/exploits/cowswap'
